import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  HStack,
  InputRightElement,
  Stack,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Link,
} from "@chakra-ui/react";
import { useState } from "react";
import { useLocation } from 'react-router-dom';
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import login_bg from "../assets/login_bg.webp";

export default function SignupPage() {
  const [showPassword, setShowPassword] = useState(false);
  const query = new URLSearchParams(useLocation().search);

  return (
    <div
      id="signup-page"
      style={{ backgroundImage: `url(${login_bg})`, backgroundSize: "cover" }}
    >
      <Flex minH={"100vh"} align={"center"} justify={"center"}>
        <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
          <Box
            rounded={"lg"}
            bg={useColorModeValue("white", "gray.700")}
            boxShadow={"lg"}
            p={8}
          >
            <Stack mb={6} align={"center"}>
              <Heading fontSize={"4xl"} textAlign={"center"}>
                Sign up
              </Heading>
            </Stack>
            <Stack spacing={4}>
              <HStack>
                <Box>
                  <FormControl id="familyName">
                    <FormLabel>姓</FormLabel>
                    <Input type="text" placeholder="小田" />
                  </FormControl>
                </Box>
                <Box>
                  <FormControl id="firstName" isRequired>
                    <FormLabel>名</FormLabel>
                    <Input type="text" placeholder="啓太" />
                  </FormControl>
                </Box>
              </HStack>
              <FormControl id="email" isRequired>
                <FormLabel>メールアドレス</FormLabel>
                <Input type="email" placeholder="oda@example.com" />
              </FormControl>
              <FormControl id="password" isRequired>
                <FormLabel>パスワード</FormLabel>
                <InputGroup>
                  <Input type={showPassword ? "text" : "password"} />
                  <InputRightElement h={"full"}>
                    <Button
                      variant={"ghost"}
                      onClick={() =>
                        setShowPassword((showPassword) => !showPassword)
                      }
                    >
                      {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
              <FormControl id="invitaionCode" isRequired>
                <FormLabel>招待コード</FormLabel>
                <Input type="text" value={query.get("invite") || ""} disabled={query.get("invite") !== null} />
              </FormControl>
              <Stack spacing={10} pt={2}>
                <Button
                  loadingText="Submitting"
                  size="lg"
                  bg={"blue.400"}
                  color={"white"}
                  _hover={{
                    bg: "blue.500",
                  }}
                >
                  登録
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    </div>
  );
}
